module.exports = __webpack_public_path__ + "img/banner.ff968def.png";